import { Checkout } from '@bigcommerce/checkout-sdk'
import request from '../request'

import { storage, constants, util } from '../utils'
import store from '../store'
import { setGlobalIsB3User } from '../store/actions'

import { errorFn } from './utils'

export const setB3CompanyInfo = async (
  roleId: string,
  customerId: number,
  userId: string
) => {
  const requestApi =
    roleId === constants.B3Role.SALESREP
      ? request.api.getSalesRepMasquerading
      : request.api.getCompany
  const query = roleId === constants.B3Role.SALESREP ? customerId : userId

  const { companyId, companyName, companyStatus } = await requestApi(
    query as never
  )

  companyStatus && storage.B3CompanyStatus.setValue(companyStatus)
  companyId && storage.B3CompanyId.setValue(companyId)
  companyName && storage.B3CompanyName.setValue(companyName)
}

export const salesRepVerify = async() => {

  const B3CustomerId = storage.B3CustomerId.getValue()
  const B3RoleId = storage.B3RoleId.getValue()

  if (B3RoleId !== constants.B3Role.SALESREP) return true

  const query = B3CustomerId

  try {
    const { companyId } = await request.api.getSalesRepMasquerading(
      query as never
    )

    if (!companyId) {
      await errorFn()

      return false
    }

    return true
  } catch (error) {
    return false
  }
}

export const setB3UserInfo = async (customerId: number) => {
  const { roleId, userId, email } = await request.api.getUserRole(customerId)

  storage.B3RoleId.setValue(roleId)
  storage.B3UserId.setValue(userId)
  storage.B3Email.setValue(email)
  storage.B3CustomerId.setValue(customerId)

  await setB3CompanyInfo(roleId, customerId, userId)
}

export default async (customerId: number, storeHash: string, checkout?: Checkout) => {
  const bcToken = await request.bcApi.getBcToken()
  if (!bcToken || !checkout) return

  try {
    const {
      channelId,
    } = checkout
    const { token } = await request.api.getToken({
      bcToken,
      customerId,
      storeHash,
      channelId,
    })

    storage.B3B2BToken.setValue(token)
    sessionStorage.setItem('sf-B3B2BToken', JSON.stringify(token))

    const {
      isEnabled,
    } = await request.api.getAllowJuniorPlaceOrders()

    storage.juniorCheckoutEnabled.setValue(isEnabled)
    await setB3UserInfo(customerId)
  } finally {
    store.dispatch(setGlobalIsB3User(util.detectB3User()))
  }
}
